
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-studies",
      function () {
        return require("private-next-pages/case-studies.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-studies"])
      });
    }
  